<template>
  <section
    class="founding-card relative overflow-hidden rounded-xl bg-gradient-to-br from-indigo-600 via-indigo-600 to-violet-700 px-3.5 py-2.5 text-start text-white shadow-md shadow-indigo-900/20 ring-1 ring-inset ring-white/15 short:py-2"
    :aria-label="t('planner.founding_badge')"
  >
    <div class="flex flex-wrap items-center justify-between gap-x-2 gap-y-1">
      <p class="inline-flex items-center gap-1.5 text-[12px] font-bold text-amber-200">
        <Star class="h-3.5 w-3.5 shrink-0 fill-amber-300 text-amber-300" aria-hidden="true"/>
        <span>{{ t('planner.founding_badge') }}</span>
      </p>
      <p
          v-if="seatsMode !== 'none'"
          class="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-emerald-400/20 px-2 py-0.5 text-[11px] font-semibold text-emerald-100 ring-1 ring-inset ring-emerald-300/40"
      >
        <span class="h-1.5 w-1.5 rounded-full bg-emerald-300" aria-hidden="true"/>
        <template v-if="seatsMode === 'count'">
          {{ t('planner.founding_seats_of', { left: seatsLeft, cap: seatCap }, seatsLeft) }}
        </template>
        <template v-else>
          {{ t('planner.founding_seats_static', { cap: seatCap }) }}
        </template>
      </p>
    </div>
    <p class="mt-1.5 text-[14px] font-semibold leading-snug short:mt-1">
      {{ t('planner.founding_headline') }}
    </p>
    <p class="mt-0.5 text-xs leading-snug text-indigo-100 short:hidden">
      {{ t('planner.founding_support') }}
    </p>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { Star } from 'lucide-vue-next'
import { useI18n } from 'vue-i18n'
import { foundingSeatsDisplay } from '@/utils/webPricing.js'

const props = defineProps({
  seatsLeft: { type: Number, default: null },
  seatCap: { type: Number, default: null },
})

const { t } = useI18n()
const seatsMode = computed(() => foundingSeatsDisplay(props.seatsLeft, props.seatCap))
</script>
